'use strict';

var _ = require('lodash');
var WhatIfResultsCriteriaService = function WhatIfResultsCriteriaService(momentService, transitionSearchCriteriaService) {
  var prepareFlightCriteria = function prepareFlightCriteria(selectedRows) {
    var flights = _.chain(selectedRows).map('flightNumber').uniq().value();
    var legs = _.chain(selectedRows).map('leg').uniq().value();
    var departures = _.chain(selectedRows).map('departureDate').uniq().value();
    return {
      transitionData: {
        searchCriteria: transitionSearchCriteriaService.whatIfFlightToFA(departures, flights, legs),
        rsqlOverride: transitionSearchCriteriaService.whatIfFlightToFAExact(selectedRows)
      }
    };
  };
  var prepareMarketCriteria = function prepareMarketCriteria(selectedRows) {
    var markets = _.chain(selectedRows).map('market').uniq().value();
    var poses = _.chain(selectedRows).map('pos').uniq().value();
    var departures = _.chain(selectedRows).map('departureDate').uniq().value();
    return {
      transitionData: {
        searchCriteria: transitionSearchCriteriaService.whatIfMarketToMA(departures, markets, poses),
        rsqlOverride: transitionSearchCriteriaService.whatIfMarketToMAExact(selectedRows)
      }
    };
  };
  var prepareServiceCriteria = function prepareServiceCriteria(selectedRows) {
    var markets = _.uniq(selectedRows.map(function (item) {
      return transitionSearchCriteriaService.extractMarketFromRouteId(item.routeId);
    }));
    var poses = _.chain(selectedRows).map('pos').filter(function (pos) {
      return !_.isNil(pos);
    }).uniq().value();
    var departures = _.chain(selectedRows).map('departureDate').uniq().value();
    return {
      transitionData: {
        searchCriteria: transitionSearchCriteriaService.whatIfMarketToMA(departures, markets, poses),
        rsqlOverride: transitionSearchCriteriaService.whatIfServiceToMAExact(selectedRows)
      }
    };
  };
  return {
    prepareFlightCriteria: prepareFlightCriteria,
    prepareMarketCriteria: prepareMarketCriteria,
    prepareServiceCriteria: prepareServiceCriteria
  };
};
WhatIfResultsCriteriaService.$inject = ['MomentService', 'TransitionSearchCriteriaService'];
module.exports = WhatIfResultsCriteriaService;